/* Overland Imports — shared landing-page behavior */
(function () {
  "use strict";

  /* Nav: solidify on scroll, hide on scroll-down, show on scroll-up */
  var nav = document.getElementById("nav");
  var lastY = window.scrollY;
  if (nav) {
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      nav.classList.toggle("solid", y > 40);
      if (y > lastY && y > 400) nav.classList.add("away");
      else nav.classList.remove("away");
      lastY = y;
    }, { passive: true });
  }

  /* Mobile menu */
  var burger = document.getElementById("burger");
  var mmenu = document.getElementById("mmenu");
  if (burger && mmenu) {
    burger.addEventListener("click", function () {
      mmenu.classList.toggle("open");
      document.body.style.overflow = mmenu.classList.contains("open") ? "hidden" : "";
    });
    mmenu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        mmenu.classList.remove("open");
        document.body.style.overflow = "";
      });
    });
  }

  /* FAQ accordion */
  document.querySelectorAll(".faq__item").forEach(function (item) {
    var q = item.querySelector(".faq__q");
    var a = item.querySelector(".faq__a");
    if (!q || !a) return;
    q.addEventListener("click", function () {
      var open = item.classList.toggle("open");
      q.setAttribute("aria-expanded", open ? "true" : "false");
      a.style.maxHeight = open ? a.scrollHeight + "px" : "0";
    });
  });

  /* Scroll reveal */
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var els = document.querySelectorAll(".rv");
  if (reduce || !("IntersectionObserver" in window)) {
    els.forEach(function (el) { el.classList.add("in"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Rotating hero on landing pages: cross-fade .lp-slide images inside
     .lp-hero__bg. A slide whose photo 404s is dropped rather than shown as a
     blank frame — the error event fires during parsing, before this runs, so
     already-failed images are detected via naturalWidth. */
  var lpWrap = document.querySelector(".lp-hero__bg");
  if (lpWrap) {
    var lpSlides = Array.prototype.slice.call(lpWrap.querySelectorAll(".lp-slide"));
    var lpCur = 0;
    function lpDrop(sl) {
      var wasOn = sl.classList.contains("on");
      lpSlides = lpSlides.filter(function (x) { return x !== sl; });
      sl.remove();
      if (wasOn && lpSlides.length) {
        lpSlides.forEach(function (x) { x.classList.remove("on"); });
        lpCur = 0;
        lpSlides[0].classList.add("on");
      }
    }
    lpSlides.slice().forEach(function (sl) {
      if (sl.complete && sl.naturalWidth === 0) { lpDrop(sl); return; }
      sl.addEventListener("error", function () { lpDrop(sl); });
    });
    if (lpSlides.length && !lpSlides.some(function (x) { return x.classList.contains("on"); })) {
      lpSlides[0].classList.add("on");
    }
    if (lpSlides.length > 1) {
      setInterval(function () {
        if (lpSlides.length < 2) return;
        lpSlides[lpCur].classList.remove("on");
        lpCur = (lpCur + 1) % lpSlides.length;
        lpSlides[lpCur].classList.add("on");
      }, 6500);
    }
  }

})();
